<template>
  <div class="page-container doctoralia-page">
    <portal to="page-name">Doctoralia</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Doctoralia</h1>
      </div>
      <div class="card-body" v-if="branchSettings?.doctoralia?.enabled">
        <facility-chooser @change="setFacility"></facility-chooser>
        <template v-if="facility">
          <div class="input-group mt-2 mb-2">
            <span class="input-group-addon">Perfil Doctoralia</span>
            <select
              class="form-select"
              :class="{ saving, readonly: !!data.id }"
              v-model="mappingId"
              :disabled="data.id"
            >
              <option value="">[Selecione]</option>
              <option v-for="facility in facilities" :value="facility.id" :key="facility.id">
                {{ facility.name }}
              </option>
            </select>
            <button
              class="btn btn-primary input-group-btn"
              :class="{ loading: loading || saving }"
              :disabled="saving || data.id"
              @click="save"
            >
              Salvar
            </button>
          </div>

          <mappings v-if="data.id"></mappings>
        </template>
      </div>
      <div class="card-body" v-else>
        <div class="empty-state">
          <div class="empty-state-icon">
            <fa-icon :icon="['fal', 'info-circle']"></fa-icon>
          </div>
          <p class="empty-state-text">
            A integração com o Doctoralia não está habilitada. Acesse as
            <router-link to="/settings" class="text-primary"> configurações </router-link>na aba
            Integração para ativar esta funcionalidade.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { MANAGE_APPOINTMENT_SETTINGS } from '@/data/actions/modules/clinical';
import { resetCache } from '@/helpers/api';
import { setBranchId } from '@/plugins/http';
import FacilityChooser from './FacilityChooser.vue';
import Mappings from './Mappings.vue';
import api from '../api';

export default {
  components: {
    FacilityChooser,
    Mappings,
  },
  data() {
    return {
      loading: false,
      saving: false,
      mappingId: '',
      facility: null,
      facilities: [],
    };
  },
  beforeDestroy() {
    this.reset();
  },
  computed: {
    ...mapState('doctoralia', {
      data: ({ data }) => data,
    }),
    ...mapGetters(['branchSettings']),
    hasAccess() {
      return this.$can(MANAGE_APPOINTMENT_SETTINGS);
    },
  },
  methods: {
    ...mapActions('doctoralia', {
      loadData: 'load',
      saveData: 'save',
      resetData: 'reset',
    }),
    async save() {
      this.saving = true;
      try {
        await this.saveData({
          mappingId: this.mappingId,
        });
      } catch (e) {
        this.$toast.error(e);
      }
      this.saving = false;
    },
    setFacility(value) {
      resetCache();
      this.facility = value || null;
      if (this.facility !== null) {
        setBranchId(this.facility.entityId);
        this.load();
      } else {
        this.reset();
      }
    },
    async load() {
      this.loading = true;
      await Promise.all([this.loadMapping(), this.loadFacilities()]);
      this.loading = false;
    },
    reset() {
      this.resetData();
      setBranchId(null);
      resetCache();
      this.facilities = [];
      this.facility = null;
    },
    async loadMapping() {
      try {
        await this.loadData();
        this.mappingId = this.data.mappingId;
      } catch (e) {
        this.$toast.error(e);
      }
    },
    async loadFacilities() {
      try {
        const { items } = await api.facility.find();
        this.facilities = items;
      } catch (e) {
        this.$toast.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.empty-state {
  text-align: center;
  padding: 3rem 1rem;

  .empty-state-icon {
    margin-bottom: 1rem;

    svg {
      font-size: 32px;
      color: #6c757d;
    }
  }

  .empty-state-title {
    font-size: 18px;
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.75rem;
  }

  .empty-state-text {
    font-size: 14px;
    color: #6c757d;
    line-height: 1.5;
    max-width: 400px;
    margin: 0 auto;

    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
